import { useAuth } from '../context/AuthContext';
import Deals from './finance/Deals';
import DesignerProjects from './DesignerProjects';

// Раньше эти же данные были доступны только через Финансы → Сделки — неудобно, если
// цель просто посмотреть/поправить проект. Здесь та же таблица (переиспользуем Deals —
// он уже правильно разграничивает admin/accountant/rop полностью и menedжера по своим
// сделкам), просто вынесенная в отдельный пункт меню верхнего уровня. У дизайнера —
// принципиально другой, урезанный вид (см. DesignerProjects).
export default function Projects() {
  const { user } = useAuth();
  if (user.role === 'designer') return <DesignerProjects />;
  return <Deals />;
}
